import React, { useState } from 'react';
import Calendar from 'react-calendar'; // Import react-calendar
import 'react-calendar/dist/Calendar.css'; // Import calendar styles
import './PopupCalendar.scss'; // Ensure styles are imported

function PopupCalendar({ events, onClose }) {
  const [selectedDate, setSelectedDate] = useState(null);

  // Handle date selection
  const handleDateClick = (date) => {
    setSelectedDate(date);
  };

  // For each day in the month view, display a green dot if there's any event
  const tileContent = ({ date, view }) => {
    if (view !== 'month') return null;
    const dayEvents = events.filter((event) => {
      return new Date(event.startTime).toDateString() === date.toDateString();
    });
    if (dayEvents.length > 0) {
      return <div className="event-dot"></div>;
    }
    return null;
  };

  // Filter and sort events for the selected date, then show only the earliest 3 events
  const eventsForSelectedDate = selectedDate
    ? events
        .filter((event) => new Date(event.startTime).toDateString() === selectedDate.toDateString())
        .sort((a, b) => new Date(a.startTime) - new Date(b.startTime))
        .slice(0, 3)
    : [];

  return (
    <div className="popup-calendar">
      <div className="popup-calendar-overlay" onClick={onClose}></div>
      <div className="popup-calendar-content">
        <button className="close-btn" onClick={onClose}>
          Close
        </button>
        <Calendar
          onClickDay={handleDateClick}
          tileContent={tileContent}
          className="big-calendar"
        />
        {selectedDate && (
          <div className="day-events">
            <h3>Tasks for {selectedDate.toDateString()}</h3>
            {eventsForSelectedDate.length > 0 ? (
              <ul>
                {eventsForSelectedDate.map((event) => (
                  <li key={event._id}>
                    <strong>
                      {new Date(event.startTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                    </strong>{' '}
                    - {event.title}
                  </li>
                ))}
              </ul>
            ) : (
              <p>No tasks for this day.</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default PopupCalendar;